import { render } from "./AddType.vue?vue&type=template&id=28d3e5da"
import script from "./AddType.vue?vue&type=script&lang=js"
export * from "./AddType.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__